<main class="u_overflow-hidden h-100">
  @if (!isScreenSharingSupported()) {
    <div class="top-menu">
      <div>
        <img
          src="https://widgets.risevision.com/apps/logos/rise-logo.svg"
          width="100"
          alt="Rise Vision"
        />
        <a class="need-help-link p-3" href="#">Need help?</a>
      </div>
    </div>
    <div class="join-panel aligner p-4">
      <div class="container p-5 flex-col aligner">
        <div class="flex-grow flex-col flex-wrap aligner mr-4 ml-4">
          <img
            class="w-25 mb-3"
            src="/images/screen-sharing/download-app.png"
            alt="Downlad App"
          />
          <h4 class="mt-4 mb-4">Download App</h4>
          <p>
            To share your screen from your phone, you need to download the
            Screen Share by Rise Vision app.
          </p>
          <a
            href="https://play.google.com/store/apps/details?id=com.risevision.rvshareandroid"
          >
            <img
              class="w-100 p-1"
              src="/images/screen-sharing/google-play.png"
              alt="Googe Play"
            />
          </a>
          <a
            href="https://apps.apple.com/us/app/rise-vision-share/id6670492603"
          >
            <img
              class="w-100 p-1"
              src="/images/screen-sharing/app-store.png"
              alt="iOS Beta Testing"
            />
          </a>
        </div>
      </div>
    </div>
  } @else if (!joined) {
    <div class="flex-row">
      <div class="join-panel flex-col p-4 u_scroll-x">
        <div class="flex-row space-between py-2 pl-3">
          <img
            src="https://widgets.risevision.com/apps/logos/rise-logo.svg"
            width="100"
            alt="Rise Vision"
          />
          <a
            class="need-help-link p-3"
            target="_blank"
            href="https://help.risevision.com/hc/en-us/articles/29009023259156-How-do-I-Set-Up-Screen-Sharing-on-a-display-in-Rise-Vision-Coming-Soon"
            >Need help?</a
          >
        </div>
        <div class="aligner flex-grow">
          <div class="join-content">
            @if (screenSharingService.channelError) {
              <div class="tw-mb-4">
                <notification-alert
                  id="screen-sharing-error"
                  type="danger"
                  [title]="screenSharingService.channelError"
                >
                </notification-alert>
              </div>
            }
            <h3 class="font-weight-bold">Share your screen</h3>
            @if (requireSecurityPin) {
              <p>Enter your secret PIN code to start sharing your screen.</p>
              <div class="form-group required pt-3" (keyup.enter)="join()">
                <label>PIN</label>
                <div class="join-code-input">
                  <code-input
                    #pinInput
                    [codeLength]="PING_LENGTH"
                    [initialFocusField]="0"
                    (codeChanged)="securityPinChanged($event)"
                    [code]="securityPin"
                  />
                </div>
                <p
                  [shown]="screenSharingService.joinCodeError"
                  class="help-block validation-error text-danger"
                >
                  {{ screenSharingService.joinCodeError }}
                </p>
                <p
                  [shown]="joinAttempted && securityPin.length < PING_LENGTH"
                  class="help-block validation-error text-danger"
                >
                  Please enter the complete PIN Code
                </p>
              </div>
            } @else if (requireAuthentication) {
              <p>Login to join a room and share your screen.</p>
              <login
                [screenSharingAuthenticationData]="{
                  joinCode: this.joinCode,
                  memberDisplayName: this.memberDisplayName,
                }"
                (isAuthenticated)="join()"
              ></login>
            } @else {
              <p>
                Enter your name and the session code on the display to join a
                room and share your screen.
              </p>
              <div class="form-group required pt-3" (keyup.enter)="join()">
                <label>Session Code</label>
                <div class="join-code-input">
                  <code-input
                    #codeInput
                    [codeLength]="CODE_LENGTH"
                    [isCharsCode]="true"
                    [inputType]="'text'"
                    [inputMode]="'text'"
                    [initialFocusField]="0"
                    (codeChanged)="joinCodeChanged($event)"
                    (codeCompleted)="joinCodeCompleted()"
                    [code]="joinCode"
                  />
                </div>
                <p
                  [shown]="screenSharingService.joinCodeError"
                  class="help-block validation-error text-danger"
                >
                  {{ screenSharingService.joinCodeError }}
                </p>
                <p
                  [shown]="joinAttempted && joinCode.length < CODE_LENGTH"
                  class="help-block validation-error text-danger"
                >
                  Please enter the complete Session Code
                </p>
              </div>
              <div class="form-group required py-3" (keyup.enter)="join()">
                <label for="nameInput">Name</label>
                <input
                  #nameInput
                  id="nameInput"
                  class="form-control"
                  placeholder="Enter your name"
                  [(ngModel)]="memberDisplayName"
                />
                <p
                  [shown]="joinAttempted && !memberDisplayName"
                  class="help-block validation-error text-danger"
                >
                  This field cannot be left blank
                </p>
              </div>
            }
            @if (!requireAuthentication) {
              <button
                rv-button
                class="tw-w-full mt-5"
                [disabled]="screenSharingService.connecting"
                (click)="join()"
              >
                @if (screenSharingService.connecting) {
                  <mat-spinner diameter="15" class="white"></mat-spinner>
                } @else {
                  Start Sharing
                }
              </button>
              <div class="align-center mt-5 py-3">
                <a
                  rv-link
                  class="p-3"
                  uiSref="apps.screen-sharing.moderator-join"
                  [uiOptions]="{
                    reload: true,
                    state: 'screen-sharing/join?rvshare',
                  }"
                  >Join as moderator</a
                >
              </div>
              <div
                class="sign-out-button-container"
                *ngIf="userStateService.isLoggedIn()"
              >
                <a
                  mat-list-item
                  class="action sign-out-button"
                  [signOutButton]="{
                    broadcast: false,
                    forceConfirmation: true,
                  }"
                  (signedOut)="signedOut($event)"
                >
                  <div class="tw-flex tw-items-center tw-gap-2.5">
                    <mat-icon
                      svgIcon="sign-out"
                      class="small medium"
                    ></mat-icon>
                    <span class="item-name">Sign Out</span>
                  </div>
                </a>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="background-panel"></div>
    </div>
  } @else {
    <div class="container p-5 h-100vh flex-col aligner joined-content">
      <screen-sharing-controls
        style="display: contents"
        [isStopped]="stopped"
        [isPaused]="paused"
        [moderatorName]="moderatorName"
        (startStream)="start()"
        (pauseStream)="pause()"
        (resumeStream)="resume()"
        (stopStream)="stop()"
        (endSession)="end()"
      >
      </screen-sharing-controls>
      <div>
        <button rv-button variant="tertiary" (click)="end()">
          <mat-icon svgIcon="sign-out"></mat-icon>
          Exit Session
        </button>
      </div>
    </div>
  }
</main>
